import { ORDER, PURCHASE } from '@/api'
import { uiHelper } from '@/utils'

const MODULE_NAME = 'order/'

/* Define Action Name */
const A_GET_CART_ITEM = 'getCartItem'
const A_ADD_CART_ITEM = 'addCartItem'
const A_EDIT_CART_ITEM = 'editCart'
const A_DELETE_CART_ITEM = 'deleteCartItem'
const A_CHANGE_VOLUME_VARIATION = 'changeProductVolumeVariation'
const A_EDIT_CHECKOUT_ITEM = 'editCheckoutItem'
const A_GET_ORDER_LIST = 'getOrderList'
const A_GET_ORDER_DETAIL = 'getOrderDetail'
const A_RESCHEDULE_ORDER = 'rescheduleOrder'
const A_GET_CANCELLATION_REASON = 'getCancellationReason'
const A_CANCEL_ORDER = 'cancelOrder'
const A_BUY_AGAIN = 'buyAgain'
const A_GET_SHIPPING = 'getShipping'
const A_REDEEM_POINT = 'redeemPoint'
const A_EDIT_DELIVERY_ADDRESS = 'editDeliveryAddress'
const A_EDIT_BILLING_ADDRESS = 'editBillingAddress'
const A_REFUND_ORDER = 'refundOrder'
const A_GET_MULTIPLE_ORDER_DETAIL = 'getMultipleOrderDetail'

/* Define Getter Name */
const G_VOUCHER_ONLY_CART = 'voucherOnlyCart'

/* Define Mutation Name */
const M_RESET_SHOPPING_CART = 'resetShoppingCart'
const M_SET_CART_ITEM = 'setCartItem'
const M_RESET_CHECKOUT_ITEM = 'resetCheckoutItem'
const M_SET_CHECKOUT_ITEM = 'setCheckoutItem'
const M_SET_ORDER_COMPLETED_DATE = 'setOrderCompletedDay'
const M_RESET_ORDER_SUMMARY = 'resetOrderSummary'
const M_SET_ORDER_SUMMARY = 'setOrderSummary'
const M_RESET_POINT = 'resetPoint'
const M_SET_POINT = 'setPoint'
const M_RESET_ARRANGE_DELIVERY = 'resetArrangeDelivery'
const M_SET_ARRANGE_DELIVERY = 'setArrangeDelivery'
const M_STORE_REFUND_FORM = 'storeRefundForm'

//define dispatch name
export const ORDER_GET_CART_ITEM = MODULE_NAME + A_GET_CART_ITEM
export const ORDER_ADD_CART_ITEM = MODULE_NAME + A_ADD_CART_ITEM
export const ORDER_EDIT_CART_ITEM = MODULE_NAME + A_EDIT_CART_ITEM
export const ORDER_DELETE_CART_ITEM = MODULE_NAME + A_DELETE_CART_ITEM
export const ORDER_CHANGE_CART_VOLUME_VARIATION = MODULE_NAME + A_CHANGE_VOLUME_VARIATION
export const ORDER_GET_SHIPPING = MODULE_NAME + A_GET_SHIPPING

const state = {
  shoppingCart: [],
  itemsForCheckout: [],
  orderSummary: {},
  point: {},
  arrangeDelivery: { date: '', time: '' },
  refundForm: {},
  orderCompletedDay: null
}

const getters = {
  [G_VOUCHER_ONLY_CART]: (state) => {
    return state.itemsForCheckout.filter((item) => item.voucher_id == 0).length === 0
  }
}

const actions = {
  async [A_GET_CART_ITEM]({ commit, dispatch }) {
    if (uiHelper.getLocalStorage('token')) {
      return await PURCHASE.getCart()
        .then((response) => {
          if (response.mycart.length > 0) {
            const items = response.mycart[0].items
            commit(M_SET_CART_ITEM, items)
            dispatch(A_EDIT_CHECKOUT_ITEM, items)
            commit(M_SET_ORDER_SUMMARY, response.order_summary)
            commit(M_SET_POINT, response)
          } else {
            commit(M_RESET_SHOPPING_CART)
            commit(M_RESET_CHECKOUT_ITEM)
            commit(M_RESET_ORDER_SUMMARY)
            commit(M_RESET_POINT)
          }
        })
        .catch((err) => console.log(err))
    }
  },
  async [A_ADD_CART_ITEM]({ commit }, data) {
    return await ORDER.addToCart(data)
      .then((response) => {
        if (response.mycart.length && response.mycart[0].items.length) {
          commit(M_SET_CART_ITEM, response.mycart[0].items)
        }
      })
      .catch((err) => console.log(err))
  },
  async [A_EDIT_CART_ITEM]({ commit, dispatch }, data) {
    return await PURCHASE.editCart(data).then((response) => {
      if (response.mycart.length && response.mycart[0].items.length) {
        const items = response.mycart[0].items
        commit(M_SET_CART_ITEM, items)
        dispatch(A_EDIT_CHECKOUT_ITEM, items)
        commit(M_SET_ORDER_SUMMARY, response.order_summary)
        commit(M_SET_POINT, response)
      }
    })
  },
  async [A_DELETE_CART_ITEM]({ dispatch }, data) {
    return await PURCHASE.deleteCartItem(data)
      .then((_response) => {
        dispatch(A_GET_CART_ITEM)
      })
      .catch((err) => console.log(err))
  },
  async [A_CHANGE_VOLUME_VARIATION]({ dispatch }, data) {
    return await PURCHASE.changeVolumeVariation(data).then((_response) => {
      dispatch(A_GET_CART_ITEM)
    })
    // .catch((err) => console.log(err))
  },
  [A_EDIT_CHECKOUT_ITEM]({ commit }, data) {
    const checkoutItem = data.filter((item) => item.is_checked)
    commit(M_SET_CHECKOUT_ITEM, checkoutItem)
  },
  async [A_GET_ORDER_LIST]({ commit }, data) {
    return await ORDER.getOrderList(data)
  },
  async [A_GET_ORDER_DETAIL]({ commit }, data) {
    return await ORDER.getOrderDetail(data)
  },
  async [A_RESCHEDULE_ORDER]({ commit, dispatch }, data) {
    return await ORDER.orderReschedule(data)
  },
  async [A_GET_CANCELLATION_REASON]({ commit, dispatch }) {
    return await ORDER.getOrderCancellationReason()
  },
  async [A_CANCEL_ORDER]({ commit, dispatch }, data) {
    return await ORDER.cancelOrder(data)
  },
  async [A_BUY_AGAIN]({ commit, dispatch }, data) {
    return await ORDER.buyAgain(data)
  },
  async [A_GET_SHIPPING]({ commit, dispatch }) {
    return await PURCHASE.getShipping()
      .then((response) => {
        commit(M_SET_ORDER_SUMMARY, response.order_summary)
        commit(M_SET_ORDER_COMPLETED_DATE, response.order_completed_day)
        commit(M_SET_POINT, response)
      })
      .catch((err) => console.log(err))
  },
  async [A_REDEEM_POINT]({ commit, dispatch }, data) {
    return await PURCHASE.redeemPoint(data).then((res) => {
      dispatch(A_GET_SHIPPING)
      return res
    })
  },
  async [A_EDIT_DELIVERY_ADDRESS]({ commit, dispatch }, id) {
    return await PURCHASE.editDeliveryAddress({ delivery_address_id: id })
  },
  async [A_EDIT_BILLING_ADDRESS]({ commit, dispatch }, id) {
    return await PURCHASE.editBillingAddress({ billing_address_id: id })
  },
  async [A_REFUND_ORDER](_, data) {
    return await ORDER.refundOrder({ ...state.refundForm, ...data })
  },
  async [A_GET_MULTIPLE_ORDER_DETAIL]({ commit }, data) {
    return await ORDER.getMultipleOrderDetail(data)
  }
}

const mutations = {
  [M_RESET_SHOPPING_CART](state) {
    state.shoppingCart = []
  },
  [M_SET_CART_ITEM](state, items) {
    state.shoppingCart = items
    console.log(
      'shoppingCart',
      state.shoppingCart.filter((f) => f.is_checked === 1)
    )
  },
  [M_RESET_CHECKOUT_ITEM](state) {
    state.itemsForCheckout = []
  },
  [M_SET_CHECKOUT_ITEM](state, items) {
    state.itemsForCheckout = items
  },
  [M_RESET_ORDER_SUMMARY](state) {
    state.orderSummary = {}
  },
  [M_SET_ORDER_SUMMARY](state, data) {
    state.orderSummary = data
  },
  [M_SET_ORDER_COMPLETED_DATE](state, data) {
    console.log('DATA', data)
    state.orderCompletedDay = data
  },
  [M_RESET_POINT](state) {
    state.point = {}
  },
  [M_SET_POINT](state, data) {
    const { point_available, point_available_conversion, point_redeemed, point_redemption_rate, total_point_earn, total_point_earn_conversion, point_redemption_conversion_rate } = data
    state.point = {
      point_available,
      point_available_conversion,
      point_redeemed,
      point_redemption_rate,
      total_point_earn,
      total_point_earn_conversion,
      point_redemption_conversion_rate
    }
  },
  [M_RESET_ARRANGE_DELIVERY](state) {
    state.arrangeDelivery = {
      date: '',
      time: ''
    }
  },
  [M_SET_ARRANGE_DELIVERY](state, data) {
    const { date, time } = data
    if (date) state.arrangeDelivery.date = date
    if (time) state.arrangeDelivery.time = time
  },
  [M_STORE_REFUND_FORM](state, data) {
    state.refundForm = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
